export default "__VITE_ASSET__Dxy5xWrb__"